module.exports = __webpack_public_path__ + "static/AboutUs-Hero-Mobile_v2-c9212aa71a67c16c0b4d53fe90caf94f.svg";